import { Component } from 'react'

export default class SortIndicator extends Component {
  render() {
    const { asc, desc } = this.props;

    if ( asc ) return "▲";
    else if ( desc ) return "▼";
    else return null;
  }
}
